import React, { FC } from "react";
import Link from "next/link";
import styles from "../../../styles/components/skills-hub/[categoryId]/Classes.module.scss";
import { Skeleton, styled } from "@mui/material";
import { LiveClassParent } from "../../../interfaces";
import Image from "next/image";
import { isOffsiteUrl } from "../../../utils/url";

const Classes: FC<Props> = ({ classes, loading }) => {
  const visibleClasses = classes.filter(
    (liveClass) => !isOffsiteUrl(liveClass?.lpExternalUrl)
  );
  return (
    <div className={styles.classes}>
      {!loading ? (
        visibleClasses.length ? (
          visibleClasses.map((liveClass: LiveClassParent) => (
            <Link
              // Absolute, because this list also renders on /skills-hub itself
              // when one category is shown inline, where a relative path would
              // resolve against the site root.
              href={
                liveClass?.lpExternalUrl ||
                `/skills-hub/${liveClass.lpCategoryId}/${liveClass.lpId}`
              }
              key={liveClass.lpId}
              target={liveClass?.lpExternalUrl && "_blank"}
            >
              <span
                className="card"
                style={{ position: "relative", overflow: "hidden" }}
              >
                <div className="thumbnail">
                  <Image
                    src={
                      liveClass.lpImage
                        ? liveClass.lpImage
                        : "/assets/images/class_thumbnail_placeholder.png"
                    }
                    alt={liveClass.lpTitle}
                    width={75}
                    height={75}
                    layout="fixed"
                  />
                </div>
                <div className="descriptions">
                  <h3 className="name">{liveClass.lpTitle}</h3>
                </div>

                {liveClass?.lpCategoryTag && (
                  <CategoryTagging>
                    <span className={liveClass?.lpCategoryTag}>
                      {liveClass?.lpCategoryTag === "sols247"
                        ? "Live class"
                        : "Self-study"}
                    </span>
                  </CategoryTagging>
                )}
              </span>
            </Link>
            // if no classes found
          ))
        ) : (
          <h2 className="subtitle">No Classes Found</h2>
        )
      ) : (
        // skeleton
        [...Array(4)]?.map((_, key) => (
          <div className="card" key={key}>
            <div className="thumbnail">
              <Skeleton variant="rectangular" width={75} height={75} />
            </div>
            <div className="descriptions">
              <Skeleton
                className="title"
                variant="text"
                width={150}
                height={32}
              />
            </div>
          </div>
        ))
      )}
    </div>
  );
};

const CategoryTagging = styled("div")(({ theme }) => ({
  span: {
    position: "absolute",
    top: "0px",
    right: "0",
    padding: "4px 10px 14px calc(10px + (15px))",
    clipPath:
      "polygon(0 0,100% 0,100% calc(100% - (10px)), calc(100% - (20px)) calc(100% - (10px)),0 calc(100% - (10px)), 16px calc(50% - (10px)/2))",
    fontSize: "12px",
    fontWeight: 600,
  },

  "& .sols247": {
    background: theme.palette.primary.main,
  },

  "& .external": {
    background: "#27619C;",
    color: "#fff",
  },
}));

interface Props {
  classes: LiveClassParent[];
  loading?: boolean;
}

export default Classes;
